import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import AOS from 'aos';
import { Form, message } from 'antd';
import MetaSeo from '../MetaSeo';
import useTrans from '../../hooks/useTrans';

export default function Solution(props) {
  const trans = useTrans();

  const dataSeo = {
    title: 'Giải pháp | TCOM Corporation',
    description:
      'TCOM đã và đang phát triển nhiều nền tảng, giải pháp công nghệ toàn diện, thúc đẩy quá trình chuyển đổi số của doanh nghiệp, tổ chức.',
  };

  const dataSeoEN = {
    title: 'Our Solutions | TCOM Corporation',
    description:
      'TCOM has been developing many comprehensive technology platforms and solutions, promoting the digital transformation process of businesses and organizations',
  };

  const data = [
    {
      id: 'Giải-pháp-Livestream-tương-tác',
      idEN: 'Interactive-Livestream-solution',
      logo: '/assets/images/solution/s1.png',
      title: trans.solution.livestream_interactive,
      content: trans.solution.solution_1,
      description: trans.solution.solution_1_description,
    },
    {
      id: 'Giải-pháp-Livestream-bán-hàng',
      idEN: 'Livestream-social-commerce-solution',
      logo: '/assets/images/solution/s2.png',
      title: trans.solution.livestream_sale,
      content: trans.solution.solution_2,
      description: trans.solution.solution_2_description,
    },
    {
      id: 'Giải-pháp-du-lịch-trực-tuyến',
      idEN: 'Online-travel-service-solution',
      logo: '/assets/images/solution/s3.png',
      title: trans.solution.service_travel,
      content: trans.solution.solution_3,
      description: trans.solution.solution_3_description,
    },
    {
      id: 'Giải-pháp-số-hóa-hình-ảnh-360-VR',
      idEN: '360-VR-image-digitization-solution',
      logo: '/assets/images/solution/s4.png',
      title: trans.solution.digital,
      content: trans.solution.solution_4,
      description: trans.solution.solution_4_description,
    },
    {
      id: 'Giải-pháp-trường-học-thông-minh',
      idEN: 'Smart-school-solution',
      logo: '/assets/images/solution/s5.png',
      title: trans.solution.school_smart,
      content: trans.solution.solution_5,
      description: trans.solution.solution_5_description,
    },
    {
      id: 'Giải-pháp-tòa-nhà-thông-minh',
      idEN: 'Smart-building-solution',
      logo: '/assets/images/solution/s7.png',
      title: trans.solution.building_smart,
      content: trans.solution.solution_6,
      description: trans.solution.solution_6_description,
    },
    {
      id: 'Giải-pháp-Cloud-Camera',
      idEN: 'AIOT-Camera-solution',
      logo: '/assets/images/solution/s6.png',
      title: trans.solution.camera,
      content: trans.solution.solution_7,
      description: trans.solution.solution_7_description,
    },
    {
      id: 'Giải-pháp-Online-Education',
      idEN: 'Online-Education-solution',
      logo: '/assets/images/solution/s8.png',
      title: trans.solution.education,
      content: trans.solution.solution_8,
      description: trans.solution.solution_8_description,
    },
    {
      id: 'Giải-pháp-Telehealth',
      idEN: 'Telehealth-solution',
      logo: '/assets/images/solution/s9.png',
      title: trans.solution.telehealth,
      content: trans.solution.solution_9,
      description: trans.solution.solution_9_description,
    },
  ];

  return (
    <>
      {trans.seoVN ? <MetaSeo {...dataSeo} /> : <MetaSeo {...dataSeoEN} />}

      <div className='main-content'>
        <div className='r-featured'>
          <div className='container'>
            <h3>{trans.solution.feature_solution}</h3>
            <div
              className='desc'
              dangerouslySetInnerHTML={{
                __html: trans.solution.feature_solution_description,
              }}
            ></div>
            <div className='list'>
              <div className='row'>
                {data.map((item, idx) => {
                  return (
                    <div className='col-6 col-md-4' key={idx}>
                      <a href={`#${trans.seoVN ? item.id : item.idEN}`}>
                        <div className='icon'>
                          <img src={item.logo} alt={item.description} />
                        </div>
                        <div
                          className='name'
                          dangerouslySetInnerHTML={{
                            __html: item.title,
                          }}
                        ></div>
                      </a>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className='r-solution-list'>
          <div className='container'>
            <ul>
              {data.map((item, idx) => {
                return (
                  <li id={trans.seoVN ? item.id : item.idEN} key={idx}>
                    <div className='box'>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.content,
                        }}
                      ></div>
                      <p
                        className='name'
                        dangerouslySetInnerHTML={{
                          __html: item.description,
                        }}
                      ></p>
                      {/* <a href='true' className='readmore'>
                                        {trans.text_button.read_more}
                                        <svg width={32} height={32} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                            <circle cx={16} cy={16} r={16} fill='#0063AA' />
                                            <path fillRule='evenodd' clipRule='evenodd' d='M5 16.2491C5 16.0501 5.07902 15.8594 5.21967 15.7187C5.36032 15.5781 5.55109 15.4991 5.75 15.4991L23.4395 15.4991L18.719 10.7801C18.5782 10.6392 18.4991 10.4482 18.4991 10.2491C18.4991 10.0499 18.5782 9.85888 18.719 9.71805C18.8598 9.57722 19.0508 9.49811 19.25 9.49811C19.4492 9.49811 19.6402 9.57722 19.781 9.71805L25.781 15.7181C25.8508 15.7877 25.9063 15.8705 25.9441 15.9616C25.9819 16.0527 26.0013 16.1504 26.0013 16.2491C26.0013 16.3477 25.9819 16.4454 25.9441 16.5365C25.9063 16.6276 25.8508 16.7104 25.781 16.7801L19.781 22.7801C19.6402 22.9209 19.4492 23 19.25 23C19.0508 23 18.8598 22.9209 18.719 22.7801C18.5782 22.6392 18.4991 22.4482 18.4991 22.2491C18.4991 22.0499 18.5782 21.8589 18.719 21.7181L23.4395 16.9991L5.75 16.9991C5.55109 16.9991 5.36032 16.92 5.21967 16.7794C5.07902 16.6387 5 16.448 5 16.2491Z' fill='white' />
                                        </svg>
                                    </a> */}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className='circle circle-1'>
            <img src='/assets/images/solution/circle-1.png' alt='' />
          </div>
          <div className='circle circle-2'>
            <img src='/assets/images/solution/circle-2.png' alt='' />
          </div>
          <div className='circle circle-3'>
            <img src='/assets/images/solution/circle-3.png' alt='' />
          </div>
          <div className='circle circle-4'>
            <img src='/assets/images/solution/circle-4.png' alt='' />
          </div>
          <div className='circle circle-5'>
            <img src='/assets/images/solution/circle-5.png' alt='' />
          </div>
        </div>
      </div>
    </>
  );
}
